import { FC } from "react";
import { Box } from "@otrium/core";
import { Range } from "rc-slider";
import { Wrapper } from "./PriceRange.styled";
import { theme } from "src/theme";

interface Props {
  range: string[];
  handleRange: (values: number[]) => void;
  onSliderChange: (values: number[]) => void;
  initialMinPrice: number;
  initialMaxPrice: number;
}

const PriceRange: FC<Props> = ({
  range,
  onSliderChange,
  handleRange,
  initialMinPrice,
  initialMaxPrice,
}) => {
  return (
    <Wrapper>
      <Box px={1}>
        <Range
          trackStyle={[
            { backgroundColor: theme.colors.tone.anthraciteDark },
            { backgroundColor: theme.colors.tone.marble },
          ]}
          handleStyle={[
            {
              backgroundColor: theme.colors.tone.anthraciteDark,
              border: "none",
              height: "16px",
              width: "16px",
              top: "4px",
              borderRadius: "8px",
              boxShadow: "none",
            },
            {
              backgroundColor: theme.colors.tone.anthraciteDark,
              border: "none",
              height: "16px",
              width: "16px",
              borderRadius: "8px",
              top: "4px",
              boxShadow: "none",
            },
          ]}
          railStyle={{ backgroundColor: theme.colors.tone.marble }}
          onChange={onSliderChange}
          onAfterChange={handleRange}
          defaultValue={[initialMinPrice, initialMaxPrice]}
          allowCross={false}
          min={initialMinPrice}
          max={initialMaxPrice}
          value={[Number(range[0]), Number(range[1])]}
        />
      </Box>
    </Wrapper>
  );
};

export default PriceRange;
